//dependencias
import React, { Component } from 'react';

//componentes
import MaestroUsuarios from './maestroUsuarios'

class Concepto extends Component {

    render(){
        return(
            <div>
                <MaestroUsuarios />
            </div>
        );
    }

}
export default Concepto;